function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 25 25"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12.582",
                cy: "12.841",
                r: "10.853",
                stroke: "#EEF",
                strokeWidth: "1.55"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.648 17.213 2-2.72 2.073 2.72h3.171L14.27 12.51l3.532-4.684h-3.063l-2 2.666-2.055-2.666H7.567l3.532 4.63-3.55 4.757h3.1Z",
                fill: "#EEF"
            })
        ]
    }));
};
export default Icon;
